import React from 'react';
import styled from 'styled-components';
import phonesImage from 'assets/images/banners/phones.png';
import gradientPurple from 'assets/images/banners/gradient_purple.png';
import { MaxIcon, TelegramIcon } from '@gr-monorepo/common/public/assets/icons';
import { StyledButton } from '@gr-monorepo/common/public/ui/Buttons/shared';
import {
  OLYMPIADS_MAX_BOT_URL,
  OLYMPIADS_TELEGRAM_BOT_URL,
} from '@gr-monorepo/common/public/ui/constants';
import { PRIMARY_BASE, SECONDARY_BASE } from '@gr-monorepo/common/public/ui/constants/colors';
import { LogClick } from 'features/shared/ClickStream';

const PromoBanner = styled.section`
  position: relative;
  width: 100%;
  background: #2a1050 url(${gradientPurple}) center / cover no-repeat;
`;

const PromoBannerInner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  max-width: var(--content-max-width);
  margin: 0 auto;
  padding: 20px 40px;
  box-sizing: border-box;
`;

const PromoBannerText = styled.p`
  position: relative;
  z-index: 2;
  flex: 1;
  min-width: 0;
  margin: 0;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const PromoBannerPhones = styled.div`
  position: absolute;
  left: calc(50% + 40px);
  top: 0;
  z-index: 1;
  transform: translateX(-50%);
  pointer-events: none;

  img {
    display: block;
    height: 80px;
    width: auto;
  }
`;

const PromoBannerActions = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

const BotLinkButton = styled(StyledButton).attrs({
  $variant: 'secondary' as const,
  $size: 'small' as const,
})`
  text-decoration: none;
  background-color: ${SECONDARY_BASE};
  color: ${PRIMARY_BASE};
  white-space: nowrap;

  &:hover,
  &:focus,
  &:visited {
    color: ${PRIMARY_BASE};
    text-decoration: none;
  }

  svg {
    display: block;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }
`;

const MainPagePromoBanner = () => (
  <PromoBanner data-testid="main-page-promo-banner">
    <PromoBannerInner>
      <PromoBannerText>Статистика олимпиад всегда под рукой в приложении Учи.ру</PromoBannerText>
      <PromoBannerPhones>
        <img src={phonesImage} alt="" aria-hidden />
      </PromoBannerPhones>
      <PromoBannerActions>
        <LogClick eventType="click" eventInfo="button_header_bot_max">
          <BotLinkButton as="a" href={OLYMPIADS_MAX_BOT_URL} target="_blank" rel="noopener noreferrer" data-testid="main-page-promo-banner-max-link">
            <MaxIcon />
            Бот в МАКС
          </BotLinkButton>
        </LogClick>
        <LogClick eventType="click" eventInfo="button_header_bot_telegram">
          <BotLinkButton as="a" href={OLYMPIADS_TELEGRAM_BOT_URL} target="_blank" rel="noopener noreferrer" data-testid="main-page-promo-banner-telegram-link">
            <TelegramIcon />
            Бот в Telegram
          </BotLinkButton>
        </LogClick>
      </PromoBannerActions>
    </PromoBannerInner>
  </PromoBanner>
);

export default MainPagePromoBanner;
